/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { ButtonProps, Heading, Icon, IconProps, VFlow } from 'bold-ui'

export interface ConfirmModalBodyProps {
  title: React.ReactNode
  type: ButtonProps['kind']
  icon?: IconProps['icon']
  children?: React.ReactNode
}

export function ModalBody(props: ConfirmModalBodyProps) {
  const { title, type, icon, children } = props

  return (
    <VFlow>
      <Heading level={3}>
        <div css={styles.titleWrapper}>
          <Icon icon={icon} fill={type} size={3} style={{ marginRight: '1rem' }} />
          {title}
        </div>
      </Heading>

      {children}
    </VFlow>
  )
}

ModalBody.defaultProps = {
  icon: 'questionMarkOutline',
} as ConfirmModalBodyProps

const styles = {
  titleWrapper: css`
    display: flex;
    align-items: center;
  `,
}
